<template>
<!-- 司机业绩汇总报表 -->
  <div class="date-template common-page">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="4" v-if="companyType === '1'">
            <el-form-item label="分公司:">
              <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                <el-option
                  v-for="item in belongCompanyData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="服务商:">
              <el-select style="width: 100%" clearable v-model="searchForm.companyId" placeholder="请选择">
                <el-option
                  v-for="item in supplierData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="司机:">
              <el-input style="width: 100%" clearable v-model="searchForm.driver" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="日期:">
              <el-date-picker style="width: 100%" :clearable="false" type="date" v-model="searchForm.date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
<!--              <el-button type="primary" :loading="downloadLoading" @click="handleDownload(`司机业绩汇总报表-${searchForm.date}.xlsx`)">导出</el-button>-->
              <el-button type="primary" @click="handleDownload()">导出</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :show-index="true"
        :selection="false"
        @pagination="handleSizeChange">
<!--        <template v-slot:mileage="{ row }">-->
<!--          <div v-if="row.mileage !== null">{{row.mileage}}</div>-->
<!--          <div v-else>-</div>-->
<!--        </template>-->
<!--        <template v-slot:totalFee="{ row }">-->
<!--          <div>当日流水: <span class="color526bec">{{row.totalFee}}元</span></div>-->
<!--          <div>技术服务费: <span class="color526bec">{{row.technicalFee}}元</span></div>-->
<!--          <div>不可退订金: <span class="color526bec">{{row.deposit}}元</span></div>-->
<!--        </template>-->
<!--        <template v-slot:dispatchNum="{ row }">-->
<!--          <div>派单量: <span class="color526bec">{{row.dispatchNum}}</span></div>-->
<!--          <div>成交单量: <span class="color526bec">{{row.completeNum}}</span></div>-->
<!--          <div>取消单量: <span class="color526bec">{{row.cancelNum}}</span></div>-->
<!--        </template>-->
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <download ref="downloadRef"></download>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import download from "./download.vue";
import {  downloadExcel, getPage } from "./api";
import dayjs from "dayjs"
import tableMixin from "@/mixin/tableMixin";
import { getSelectSupplier } from "@/views/SystemManagement/ServiceManagement/api";
export default {
  name: "DriverPerformanceReport",
  mixins: [tableMixin],
  components: {
    OperateBox,
    download,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadExcel,
      searchForm: {
        driver: "",
        companyId: "",
        belongCompanyId: "",
        date: dayjs().format("YYYY-MM-DD"),
      },
      haveBelongCompany: true,
      tableColumn: [
        {
          label: "服务商",
          prop: "companyName",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "driverName",
          show: true,
        },
        {
          label: "车牌号",
          prop: "carNumber",
          show: true,
        },
        {
          label: "派单调度",
          prop: "dispatcherName",
          show: true,
        },
        {
          label: "线路",
          prop: "lines",
          show: true,
        },
        {
          label: "派单量",
          prop: "dispatchNum",
          show: true,
        },
        {
          label: "成交单量",
          prop: "completeNum",
          show: true,
        },
        {
          label: "取消单量",
          prop: "cancelNum",
          show: true,
        },
        {
          label: "当日流水",
          prop: "totalFee",
          show: true,
        },
        {
          label: "技术服务费",
          prop: "technicalFee",
          show: true,
        },
        {
          label: "不可退订金",
          prop: "deposit",
          show: true,
        },
        {
          label: "公里数",
          prop: "mileage",
          show: true,
        },
        {
          label: "日期",
          prop: "date",
          show: true,
        },

      ],
      isImmediatelyGetData: true,
      supplierData: []
    };
  },
  watch: {
    "searchForm.belongCompanyId":function(val) {
      this.searchForm.companyId = ""
      this.getSelectSupplierData(val)
    }
  },
  created() {
    // this.getSelectSupplierData()
  },
  methods: {
    handleDownload() {
      this.$refs.downloadRef.init(this.searchForm)
    },
    getSelectSupplierData(val) {
      getSelectSupplier({belongCompanyId: val, keyword: ''}).then(response => {
        if (response.code === 200) {
          this.supplierData = response.data
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.date-template {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-form-box{
    flex-shrink: 0;
  }
  .custom-table-box {
    flex: 1;
    padding-left: 0;
    padding-top: 0;
  }
}
</style>
